import React, { useEffect, useContext, useState, useMemo } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Login from './components/login/Login';
import Calculator from './components/calculator/Calculator';
import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
// import FirebaseTesting from './components/FirebaseTesting';
import { FirebaseService } from './services/FirebaseService';
import { UserContext } from './components/context/User';
import { NotificationContext } from './components/context/Notification';
import { collections } from './constants';
import Notification from './components/Notification';
import { CalcsContext } from './components/context/Calcs';
import './App.css';

function App() {
  const { setUser } = useContext(UserContext);
  const { setNotification } = useContext(NotificationContext);
  const { setCalcMap, setItemMap } = useContext(CalcsContext);
  const [activeCalculator, setActiveCalculator] = useState("deck");
  const navigate = useNavigate();
  const [calcs, setCalcs] = useState(null);
  const [items, setItems] = useState(null);

  const fire = useMemo(() => {
    return new FirebaseService(setUser, setNotification);
  }, [setUser, setNotification]);

  useEffect(() => {
    async function fetchData() {
      try {
        await fire.login();
        const [calc, item] = await Promise.all([
          fire.getCollectionDocs(collections.calcs),
          fire.getCollectionDocs(collections.items)
        ]);
        setCalcs(calc);
        setItems(item);

        if(calc && item) {
          setCalcMap(calc);
          let itemMap = {}
          Object.keys(calc)?.forEach(key => {
            if (!itemMap[key]) {
              itemMap[key] = {}
            }
            calc[key].fields.forEach(field => {
              if (field.collection) {
                itemMap[key][field.collection] = item[field.collection]
              }
            });
          });
          setItemMap(itemMap);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, [fire, setCalcMap, setItemMap]);

  function logout() {
    fire.logout().then(() => {
      navigate('/kci/admin/login/user');
    });
  }

  return (
    <div>
      {/* <FirebaseTesting /> */}
      <Navbar setActiveCalculator={setActiveCalculator} logout={logout} />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/kci/admin/login/user" element={<Login fire={fire} />} />
        <Route path="/*" element={
          <Calculator
            activeCalculator={activeCalculator}
            calcObj={calcs}
            itemObj={items}
          />
        } />
        <Route path="*" element={<Home />} />
      </Routes>

      <Notification />
    </div>
  );
}

export default App;